(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(54198);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Main; }
/* harmony export */ });
/* harmony import */ var app_features_component_guards_AuthGuard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62526);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20458);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





Main.getLayout = function(page) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(app_features_component_guards_AuthGuard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        toast: false,
        children: page
    });
};
function Main() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        router.replace(_bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_2__/* .PATH_OBJ.TAB_BAR_HOME */ .dx.TAB_BAR_HOME).catch(console.error);
    }, [
        router
    ]);
    return null;
}


/***/ }),

/***/ 98978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ userFetcher; }
/* harmony export */ });
/* harmony import */ var _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4664);
/* harmony import */ var app_utils_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44064);
/* harmony import */ var app_utils_storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15551);



let repository;
function userRepository() {
    if (repository) return repository;
    repository = {
        getUserInfo: async ()=>{
            const { data  } = await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/ug/consulting/user");
            return data;
        },
        updateUserInfo: async (newUser)=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].patch */ .Z.patch("/ug/consulting/user", {
                ...newUser
            });
        },
        userQuit: async (quitReason)=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/ug/consulting/user-quit", {
                quitReason
            });
        },
        updateLastLoginDate: async ()=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].patch */ .Z.patch("/ug/consulting/users/last-login-date");
        }
    };
    return repository;
}
/* harmony default export */ __webpack_exports__["Z"] = (userRepository());
const userFetcher = async ()=>{
    const idToken = app_utils_storage__WEBPACK_IMPORTED_MODULE_2__/* .getIdToken */ .lI();
    if (!idToken) {
        throw new _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .ClientError */ .XF({
            message: "로그인이 되어있지 않습니다.",
            code: _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .EMPTY_TOKEN */ .Wq
        });
    }
    const { data  } = await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/ug/consulting/user");
    if (!data) {
        throw new _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .ClientError */ .XF({
            message: "존재하지 않는 유저입니다.",
            code: _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .INVALID_TOKEN */ .fs
        });
    }
    return data;
};


/***/ }),

/***/ 62526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthGuard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89930);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _bridge_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91212);
/* harmony import */ var app_api_UserRepository__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98978);
/* harmony import */ var app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61432);
/* harmony import */ var app_features_component_LoadingSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93804);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var app_hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62181);
/* harmony import */ var _bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20458);










const { updateLastLoginDate  } = app_api_UserRepository__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
function AuthGuard(param) {
    let { children , toast =true  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { isLoading , error , isLoggedOut  } = (0,app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    if (isLoading || !router.isReady) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_features_component_LoadingSpinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    }
    if (isLoggedOut) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoggedOut, {
            toast: toast
        });
    }
    if (error) {
        // go to error boundary
        // 예기치 못한 에러
        throw error;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoggedIn, {
        children: children
    });
}
function LoggedOut(param) {
    let { toast  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { logout  } = (0,app_hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLoggedOut = async ()=>{
            if (toast) {
                _bridge_ui__WEBPACK_IMPORTED_MODULE_2__/* .Toast.show */ .FNi.show({
                    description: "로그인 이후 이용 가능합니다."
                });
            }
            const isLandingToMainPage = [
                window.location.pathname === "/parent/",
                new URLSearchParams(window.location.search).get("path") === "my-page"
            ].some(lodash_es__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z);
            // 인코딩된 url을 넘겨주지 않으면 주소의 "&"부터
            // 주소창에서 없어지면서 해당 페이지로 넘어가질 않음
            const url = isLandingToMainPage ? "/log-in?return-url=/" : "/log-in?return-url=".concat(encodeURIComponent(window.location.pathname + window.location.search));
            await router.push(url);
        };
        handleLoggedOut().catch(console.error);
    }, [
        logout,
        router,
        toast
    ]);
    return null;
}
function LoggedIn(param) {
    let { children  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { user  } = (0,app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    const isDaekyoUser = (user === null || user === void 0 ? void 0 : user.userDetailType) === "daekyo";
    const isInitUser = (user === null || user === void 0 ? void 0 : user.gender) === "U";
    const isNeedToRouting = isDaekyoUser && isInitUser && router.pathname !== _bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.AUTH_AGREEMENT */ .mD.Yl;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        updateLastLoginDate().catch(console.error);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isNeedToRouting) {
            return;
        }
        void router.replace(_bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.AUTH_AGREEMENT */ .mD.Yl);
    }, [
        isNeedToRouting,
        router
    ]);
    if (isNeedToRouting) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}


/***/ }),

/***/ 61432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useSuspenseUser; },
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4664);
/* harmony import */ var app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98978);
/* harmony import */ var app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94880);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3255);




// { revalidate: false } 일 경우 유저 정보 갱신 안함.
// 외부에 인해 변하는 유저의 실시간 데이터가 필요할 때 { revalidate: true }
// ex) user.consultant, user.emailAuth, ... 등등
const useSuspenseUser = function() {
    let { revalidate =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data: user , mutate  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__/* .API_USER */ .zh, app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__/* .userFetcher */ .E, {
        suspense: true,
        ...!revalidate && {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
    return {
        mutate,
        user
    };
};
const useUser = function() {
    let { revalidate =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data: user , error , mutate , isLoading , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__/* .API_USER */ .zh, app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__/* .userFetcher */ .E, {
        suspense: false,
        ...!revalidate && {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
    // 토큰이 없거나 토큰으로 조회한 유저 정보가 없을 때
    const isLoggedOut = (0,_bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .isClientError */ .pI)(error) && (error.code === _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .EMPTY_TOKEN */ .Wq || error.code === _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .INVALID_TOKEN */ .fs);
    const isLoggedIn = !error && !!user;
    return {
        error,
        mutate,
        user,
        isLoading,
        isLoggedOut,
        isLoggedIn,
        isValidating
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);